import axios from '../api/config.js'
import { getOSSAuth } from '../api/authAPI'
import OSS from 'ali-oss'

class CustomOSSClient {
  client

  constructor () {
    this.client = {}
  }

  async init () {
    const credentials = await new Promise((resolve) => {
      console.log(localStorage.token)
      axios.get(getOSSAuth)
        .then((response) => {
          console.log('ossresponse:', response)
          resolve(response.data.Credentials)
        })
        .catch(err => {
          console.log('ossError:', err.response)
        })
    })
    this.client = new OSS({
      region: process.env.VUE_APP_OSS_REGION,
      accessKeyId: credentials.AccessKeyId,
      accessKeySecret: credentials.AccessKeySecret,
      stsToken: credentials.SecurityToken,
      bucket: process.env.VUE_APP_OSS_BUCKET
    })
  }

  getSignedUrl (path) {
    return this.client.signatureUrl(path)
  }

  getUrl (path) {
    return this.client.getObjectUrl(path, 'https://wudongmeiyu2020.oss-cn-shanghai.aliyuncs.com/')
  }
}

export default CustomOSSClient
